// extracted by mini-css-extract-plugin
export default {"InfoMessage":"InfoMessage_InfoMessage__8rIWf"};